/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  commentvolume: {
    '& .kudostip': {
      background: '#FFF',
      boxShadow: '0px 0px 8px 0px #00000033',
      borderRadius: pxToEm(8),
      height: pxToEm(60),
      width: pxToEm(170),
      fontWeight: 600,
      '&::after': {
        content: '""',
        borderTop: '10px solid #fff',
        borderRight: '10px solid transparent',
        borderLeft: '10px solid transparent',
        position: 'relative',
        bottom: `-${pxToEm(35)}`,
        left:  `-${pxToEm(65)}`,
        filter: 'drop-shadow(0 1px 1px #00000033)'
      }
    },
    '& .button': {
      marginTop: pxToEm(8),
      height: pxToEm(40),
      background: '#061240',
      color: '#FFF',
      borderRadius: pxToEm(12),
      padding: `${pxToEm(10)} ${pxToEm(16)}`
    },
    '& .explainer': {
      '& ul': {
        paddingLeft: pxToEm(20),
        marginBottom: pxToEm(20),
        '& li': {
          fontSize: pxToEm(14),
          marginBottom: pxToEm(10)
        }
      }
    },
    '& .warningmessage': {
      marginTop: pxToEm(15),
      '& .warningicon': {
        '& path': {
          fill: '#7E92B8'
        }
      }
    },
    '& .qualifier': {
      fontSize: pxToEm(14),
      color: themeV2.color.base.gray.dark,
      fontStyle: 'italic'

    },
    '& previewconfig': {
      maxWith: pxToEm(540)
    }
  }
});
